class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    this.querySelector('form').addEventListener('input', this.debouncedOnSubmit.bind(this));

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    }
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    let bfcm = document.querySelector('.bfcm-navigation');
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');

    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
    if (countContainer){
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop){
      countContainerDesktop.classList.add('loading');
    }

    sections.forEach((section) => {
      let url='';
      if(bfcm){
        const bfcmSelectedUrl = bfcm.querySelector(".thumbnail-item.thumbnail-item--active a").href+'?'+searchParams;
        url = bfcmSelectedUrl;
      }
      else
        url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = element => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl) ?
        FacetFiltersForm.renderSectionFromCache(filterDataUrl, event) :
        FacetFiltersForm.renderSectionFromFetch(url, event);
    });
    if(bfcm){}
    else
      if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then(response => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
  }

  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductGridContainer').innerHTML;
  }

  static renderProductCount(html) {
    if(new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount')) {
      const count = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount').innerHTML
      const container = document.getElementById('ProductCount');
      const containerDesktop = document.getElementById('ProductCountDesktop');
      container.innerHTML = count;
      container.classList.remove('loading');
      if (containerDesktop) {
        containerDesktop.innerHTML = count;
        containerDesktop.classList.remove('loading');
      }
    }
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

    const facetDetailsElements =
      parsedHTML.querySelectorAll('#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter');
    const matchesIndex = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
    }
    const facetsToRender = Array.from(facetDetailsElements).filter(element => !matchesIndex(element));
    const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

    facetsToRender.forEach((element) => {
      document.querySelector(`.js-filter[data-index="${element.dataset.index}"]`).innerHTML = element.innerHTML;
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    })

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });

    const mobileForm = document.getElementById('FacetFiltersFormMobile');
    if (mobileForm) {
      const drawerEl = mobileForm.closest('menu-drawer')
      if (drawerEl && typeof drawerEl.bindEvents === 'function') {
        drawerEl.bindEvents();
      }
    }
  }

  static renderCounts(source, target) {
    const targetElement = target.querySelector('.facets__selected');
    const sourceElement = source.querySelector('.facets__selected');

    if (sourceElement && targetElement) {
      target.querySelector('.facets__selected').outerHTML = source.querySelector('.facets__selected').outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      }
    ]
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const formData = new FormData(event.target.closest('form'));
    const searchParams = new URLSearchParams(formData).toString();

    if(searchParams != ""){
      this.prepareGTMTracking(searchParams, event);
    }
    FacetFiltersForm.renderPage(searchParams, event);
  }

  prepareGTMTracking(searchParams, event) {
    if(!event || !event.target) return;
    let clickedCategory = '';
    let clickedColor = '';
    let clickedAgeGroup = '';
    let eventName = "Clicked - filter options";
    let selectedTitle = "itemTitle";

    if(event.target.name == 'filter.p.m.custom.product_category'){
      const metaobjectID = event.target.value;
      const input = document.querySelector(`input[value="${metaobjectID}"]`);

      if (input) {
        const label = input.closest('label');
        if (label) {
          clickedCategory = label.textContent.trim();
        }
      }
      eventName = "Clicked - Category Filter";
      selectedTitle = "productCategory";
      this.gtmTracking(eventName, clickedCategory, selectedTitle);
    }
    if(event.target.name == 'filter.v.option.color'){
      clickedColor = event.target.value;
      eventName = "Clicked - Color Filter";
      selectedTitle = "productColor";
      this.gtmTracking(eventName, clickedColor, selectedTitle);
    }

    if(event.target.name == 'filter.p.m.custom.product_age_range'){
      clickedAgeGroup = event.target.parentElement.textContent.trim();
      eventName = "Clicked - Age Filter";
      selectedTitle = "ageGroup";
      this.gtmTracking(eventName, clickedAgeGroup, selectedTitle);
    }

    //this.gtmTracking(eventName, clickedCategory, clickedColor, clickedAgeGroup);
  }

  gtmTracking(eventName, itemValue, selectedTitle) {
    if(eventName == "") return;

    let collectionTabValue='';
    let bfcmTab = document.querySelector('.bfcm-navigation .thumbnail-item--active a');

    if(bfcmTab){
      let bfcmTabName = bfcmTab.getAttribute('aria-label') || bfcmTab.textContent.trim();
      collectionTabValue = bfcmTabName;
    }
    if(eventName == "") return;
    window.dataLayer.push({
      event: eventName
          ? eventName
          : "Clicked - filter options",
      [selectedTitle]: itemValue
          ? itemValue
          : "No Category Found",
      bfcmTab: collectionTabValue
          ? collectionTabValue
          : "No Collection Tab Found",
      pagePath: window.location.pathname,
      pageTitle: document.title,
    });
    window.dataLayer.push({

    });
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url = event.currentTarget.href.indexOf('?') == -1 ? '' : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();




class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input')
      .forEach(element => element.addEventListener('change', this.onRangeChange.bind(this)));

    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('min', 0);
    if (maxInput.value === '') minInput.setAttribute('max', maxInput.getAttribute('max'));

    if(minInput.value || maxInput.value)
      this.gtmTracking(minInput.value, maxInput.value);
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('min'));
    const max = Number(input.getAttribute('max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }

  gtmTracking(min, max) {
    let eventName = "Clicked - Price Filter";
    if(!min) min = '0';
    let priceRange = `${min}-${max}`;
    let collectionTabValue='';



    if(eventName == "") return;
    let bfcmTab = document.querySelector('.bfcm-navigation .thumbnail-item--active a');
    if(bfcmTab){
      let bfcmTabName = bfcmTab.getAttribute('aria-label') || bfcmTab.textContent.trim();
      collectionTabValue = bfcmTabName;
    }

    window.dataLayer.push({
      event: eventName
          ? eventName
          : "Clicked - filter options",
      productPrice: priceRange
          ? priceRange
          : "No price range Found",
      bfcmTab: collectionTabValue
          ? collectionTabValue
          : "No Collection Tab Found",
      pagePath: window.location.pathname,
      pageTitle: document.title,
    });
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    this.querySelector('a').addEventListener('click', (event) => {
      event.preventDefault();
      const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
      form.onActiveFilterClick(event);
    });
  }
}

customElements.define('facet-remove', FacetRemove);

class UnifiedPriceRange extends HTMLElement {
  constructor() {
    super();
    this.isSyncing = false;
    this.isMobile = this.getAttribute('type') === 'mobile';
    this.handlePriceRangeClick = this.handlePriceRangeClick.bind(this);
  }

  connectedCallback() {
    this.initializePriceRange();
    this.loadInitialState();
    //this.setupCrossComponentSync();
  }

  initializePriceRange() {
    this.querySelectorAll('li input[type="radio"]').forEach(input => {
      input.addEventListener('change', (e) => this.handlePriceRangeClick(e));
    });
  }

  handlePriceRangeClick(event) {
    if (this.isSyncing) return;

    const input = event.target;
    const min = input.getAttribute('data-min');
    const max = input.getAttribute('data-max');

    this.querySelectorAll('input[type="radio"]').forEach(i => i.checked = false);
    input.checked = true;

    const prefix = this.isMobile ? 'Mobile-' : '';
    const minInput = document.getElementById(`${prefix}Filter-Price-GTE`);
    const maxInput = document.getElementById(`${prefix}Filter-Price-LTE`);

    if (minInput && maxInput) {
      minInput.value = min;
      maxInput.value = max;
      this.setupCrossComponentSync(min, max);
      this.gtmTracking(min, max);
    }
  }

  loadInitialState() {
    const params = new URLSearchParams(window.location.search);
    let min = params.get("filter.v.price.gte");
    let max = params.get("filter.v.price.lte");
    if (min && max) {
      const matchingInput = this.querySelector(`input[data-min="${min}"][data-max="${max}"]`);
      if (matchingInput) matchingInput.checked = true;
    }

    const prefix = this.isMobile ? 'Mobile-' : '';
    const minInputEl = document.getElementById(`${prefix}Filter-Price-GTE`) || document.getElementById('Filter-Price-GTE');
    const maxInputEl = document.getElementById(`${prefix}Filter-Price-LTE`) || document.getElementById('Filter-Price-LTE');

    if (minInputEl && maxInputEl && minInputEl.value !== '' && maxInputEl.value !== '') {
      min = minInputEl.value;
      max = maxInputEl.value;
    } else {
      const params = new URLSearchParams(window.location.search);
      min = params.get("filter.v.price.gte");
      max = params.get("filter.v.price.lte");
    }

    if (min && max) {
      const matchingInput = this.querySelector(`input[data-min="${min}"][data-max="${max}"]`);
      if (matchingInput) {
        this.querySelectorAll('input[type="radio"]').forEach(i => i.checked = false);
        matchingInput.checked = true;
        matchingInput.dispatchEvent(new Event('change', { bubbles: true }));
        //void matchingInput.offsetHeight;
      }
    }
  }

  gtmTracking(min, max) {
    let itemTitle = "filterTracking";
    let eventName = "Clicked - Price filter";
    let priceRange = `${min}-${max}`;

    window.dataLayer.push({
      event: eventName
          ? eventName
          : "Clicked - Price filter",
        itemTitle: priceRange
            ? priceRange
            : "No price range Found",
      pagePath: window.location.pathname,
      pageTitle: document.title,
    });
  }

  setupCrossComponentSync(min, max) {
    if (this.syncTimeout) {
      clearTimeout(this.syncTimeout);
    }

    this.syncTimeout = setTimeout(() => {
      let allPriceRangeComponents = document.querySelectorAll('unified-price-range');

      allPriceRangeComponents.forEach(component => {
        if (component.getAttribute('type') === this.getAttribute('type')) return;

        let matchingInput = component.querySelector(`input[data-min="${min}"][data-max="${max}"]`);

        if (matchingInput) {
          component.querySelectorAll('input[type="radio"]').forEach(i => {
            if(i.getAttribute('data-min') == min && i.getAttribute('data-max') == max)
              i.checked = true
            else
              i.checked = false
          });
        }
      });
    }, 100);
  }

  setupCrossComponentSync1() {
    window.addEventListener('priceRange:change', (e) => {
      const { min, max, fromMobile } = e.detail;
      if (fromMobile === this.isMobile) return;

      this.isSyncing = true;
      const matchingInput = this.querySelector(`input[data-min="${min}"][data-max="${max}"]`);
      this.querySelectorAll('input[type="radio"]').forEach(i => i.checked = false);
      if (matchingInput) matchingInput.checked = true;

      const prefix = this.isMobile ? 'Mobile-' : '';
      const minInput = document.getElementById(`${prefix}Filter-Price-GTE`);
      const maxInput = document.getElementById(`${prefix}Filter-Price-LTE`);
      if (minInput && maxInput) {
        minInput.value = min;
        maxInput.value = max;
      }

      setTimeout(() => (this.isSyncing = false), 100);
    });
  }
}

customElements.define('unified-price-range', UnifiedPriceRange);
